// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
/*引入elementui*/
import ElementUI from 'element-ui'
//样式需要单独引入
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store' //npm i vuex //todo  ①
import {post,fetch,patch,put} from '../static/js/http.js'//todo ②/*公共axios*/
import axios from 'axios' // npm i axios //todo  ②/*公共axios*/
import qs from 'qs' //npm i qs  //todo     ③/*qs*/
import $ from 'jquery'     //todo   ④/*jq*/
import VueResource from 'vue-resource' //todo  ⑤/*this.$http.jsonp(this.http +....)需要安装*/
/*Echarts*/
import * as echarts from 'echarts';/*⑥ npm install echarts -S*/
import './assets/font/iconfont.css' /*自定义字体图标*/
import UUID from 'vue-uuid' /*⑦获取uuid npm i vue-uuid*/
import BaiduMap from 'vue-baidu-map';/*⑧百度地图 npm i vue-baidu-map --save*/
Vue.use(BaiduMap, {
	ak: 'YcP5EukTHUoFR3oObxdfBHTfA3EUgHET'
})

Vue.use(VueResource)
Vue.use(UUID)

//less样式的引入
//import less from 'less'
//Vue.use(less)
//挂载 ElementUI
Vue.use(ElementUI)

/*axios*/
//挂载 axios
//Vue.prototype.$http=axios
Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'//最主要的一句
Vue.prototype.$post=post;
Vue.prototype.$fetch=fetch;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js